import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-5 w-full" }
const _hoisted_2 = { class: "whitespace-nowrap font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "whitespace-nowrap font-semibold cursor-pointer" }, "Tutup", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", { class: "flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isExpand)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "flex text-red-lp-300 flex-grow-0 flex-shrink-0 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onExpand && _ctx.onExpand(...args)))
        }, [
          _createVNode(_component_Icons, {
            name: "chevron-up-down",
            style: {"width":"18px"}
          }),
          _createVNode("span", _hoisted_2, " Lihat " + _toDisplayString(_ctx.countSeeMore) + " Balasan Lainnya ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isHide)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "flex text-red-lp-300 flex-grow-0 flex-shrink-0 cursor-pointer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onHide && _ctx.onHide(...args)))
        }, [
          _createVNode(_component_Icons, {
            name: "chevron-down-up",
            style: {"width":"18px"}
          }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _hoisted_4
  ]))
}